import {FavoriteStore} from "../init";


const favoriteGetAllLocal = async () => FavoriteStore.getList();
export default favoriteGetAllLocal;